import moment from 'moment';
import { EditProfile } from '_components/Profile/EditProfile';
import { getProgressStatusText } from '_helpers/helpers';
import { dateTimeConstants } from '_constants';
import DatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import PropTypes from "prop-types";

export default function ViprContract({
  profileData,
  refetchUser,
  currentUserPermissions,
  authUser,
}) {
  return (
    <div className='mb-2'>
      <div>
        <div className='qualifications_header-tab'>
          <h3>VIPR Contract</h3>
        </div>
      </div>
      <div className='qualifications_header-tab'>
        <div className='qualification-row'>
          <label>FFT1</label>
          <div className='input-like-box'>
            <div className='input-like-box_field'>
              <span>
                {profileData.vipr_fft1_status
                  ? getProgressStatusText(
                      profileData.vipr_fft1_status,
                      profileData.vipr_fft1_date,
                    )
                  : '-'}
              </span>
            </div>

            <EditProfile
              label='VIPR FFT1'
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={currentUserPermissions.includes(
                'Manage Expiry/Assigned Dates',
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Status</label>
                  <select
                    {...register('vipr_fft1_status', {
                      required: 'Status is required',
                    })}
                    defaultValue={profileData.vipr_fft1_status}
                    className={
                      errors.vipr_fft1_status && 'profile-form-field-error'
                    }
                  >
                    <option value=''>Select Status</option>
                    <option value='1'>Sent</option>
                    <option value='2'>Approved</option>
                  </select>
                  {errors.vipr_fft1_status && (
                    <p className='error-message'>
                      {errors.vipr_fft1_status.message}
                    </p>
                  )}

                  <label>Date</label>
                  <Controller
                    name='vipr_fft1_date'
                    control={control}
                    defaultValue={
                      profileData.vipr_fft1_date
                        ? moment(profileData.vipr_fft1_date).format(
                            dateTimeConstants.DATE_FORMAT,
                          )
                        : null
                    }
                    rules={{
                      required: 'Date is required',
                    }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : '',
                          )
                        }
                        customInput={<input inputMode='none' />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText='Select Date'
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.vipr_fft1_date && (
                    <p className='error-message'>
                      {errors.vipr_fft1_date.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </div>
        </div>

        <div className='qualification-row'>
          <label>ENGB</label>
          <div className='input-like-box'>
            <div className='input-like-box_field'>
              <span>
                {profileData.vipr_engb_status
                  ? getProgressStatusText(
                      profileData.vipr_engb_status,
                      profileData.vipr_engb_date,
                    )
                  : '-'}
              </span>
            </div>
            <EditProfile
              label='ENGB'
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={currentUserPermissions.includes(
                'Manage Expiry/Assigned Dates',
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Status</label>
                  <select
                    {...register('vipr_engb_status', {
                      required: 'Status is required',
                    })}
                    defaultValue={profileData.vipr_engb_status}
                    className={
                      errors.vipr_engb_status && 'profile-form-field-error'
                    }
                  >
                    <option value=''>Select Status</option>
                    <option value='1'>Sent</option>
                    <option value='2'>Approved</option>
                  </select>
                  {errors.vipr_engb_status && (
                    <p className='error-message'>
                      {errors.vipr_engb_status.message}
                    </p>
                  )}

                  <label>Date</label>
                  <Controller
                    name='vipr_engb_date'
                    control={control}
                    defaultValue={
                      profileData.vipr_engb_date
                        ? moment(profileData.vipr_engb_date).format(
                            dateTimeConstants.DATE_FORMAT,
                          )
                        : null
                    }
                    rules={{
                      required: 'Date is required',
                    }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : '',
                          )
                        }
                        customInput={<input inputMode='none' />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText='Select Date'
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.vipr_engb_date && (
                    <p className='error-message'>
                      {errors.vipr_engb_date.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </div>
        </div>
      </div>
    </div>
  );
}

ViprContract.propTypes = {
  profileData: PropTypes.object.isRequired,
  refetchUser: PropTypes.func,
  currentUserPermissions: PropTypes.array,
  authUser: PropTypes.any,
};
